import React, { useState, useEffect } from 'react';
import { Avatar, Tooltip } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { User } from '../../types';

interface TgAvatarProps {
    user: User;
    style?: React.CSSProperties;
    size?: 'large';
}

/** Светлый фон + серая иконка — читаемо и на светлой, и на тёмной теме */
const FALLBACK_AVATAR_STYLE: React.CSSProperties = {
    backgroundColor: '#f0f0f0',
    color: '#8c8c8c',
};

const TgAvatar: React.FC<TgAvatarProps> = ({ user, size, style }) => {
    const fullName = user.lastName ? `${user.firstName} ${user.lastName}` : user.firstName;
    const telegramLink = `https://t.me/${user.username}`;
    const [isValidImage, setIsValidImage] = useState<boolean | null>(
        user.photoUrl ? null : false,
    );

    useEffect(() => {
        if (!user.photoUrl) {
            setIsValidImage(false);
            return undefined;
        }

        let cancelled = false;
        setIsValidImage(null);

        const img = new Image();
        img.onload = () => {
            if (!cancelled) {
                setIsValidImage(img.width > 1 && img.height > 1);
            }
        };
        img.onerror = () => {
            if (!cancelled) {
                setIsValidImage(false);
            }
        };
        img.src = user.photoUrl;

        return () => {
            cancelled = true;
        };
    }, [user.photoUrl]);

    const showPhoto = isValidImage === true;
    const avatarStyle = showPhoto
        ? style
        : { ...FALLBACK_AVATAR_STYLE, ...style };

    return (
        <Tooltip
            title={(
                <div>
                    <div>
                        <a href={telegramLink} target="_blank" rel="noopener noreferrer">
                            @{user.username}
                        </a>
                    </div>
                    <div>{fullName}</div>
                    <div>ID: {user.userId}</div>
                </div>
            )}
            placement="top"
        >
            {/* span: Tooltip нужен DOM-узел с ref; у Avatar ref нестабилен */}
            <span className="app-avatar-wrap" style={{ display: 'inline-flex', lineHeight: 0 }}>
                <Avatar
                    src={showPhoto ? user.photoUrl : undefined}
                    size={size}
                    style={avatarStyle}
                    icon={!showPhoto ? <UserOutlined /> : undefined}
                    aria-label={fullName || user.username}
                />
            </span>
        </Tooltip>
    );
};

export default TgAvatar;
